<app-organization-rider-payment-account-form
  [paymentAccount]="data.paymentAccount"
  [isEditMode]="data.isEditMode"
  [submittingPaymentAccount]="(submittingPaymentAccount$ | async) ?? false"
  (cancel)="dialogRef.close()"
  (create)="handleCreatePaymentAccount($event)"
  (update)="handleUpdatePaymentAccount($event)"
  (delete)="handleDeletePaymentAccount()">
</app-organization-rider-payment-account-form>
